import { Text } from '@/utils';

export const props = {
    props:
    {
        blank:
        {
            type: Boolean,
            default: false,
        },

        border:
        {
            type: Boolean,
            default: true,
        },

        error:
        {
            type: String,
            default: null,
        },

        label:
        {
            type: String,
            default: null,
        },

        margin:
        {
            type: Boolean,
            default: true,
        },

        size:
        {
            type: String,
            default: null, // 'small', 'large'
        },

        success:
        {
            type: Boolean,
            default: false,
        },

        value: [String, Number],

        modelValue: [String, Number],

        width:
        {
            type: String,
            default: null, // 'xsmall', 'small', 'medium', 'large', '1-*'
        },

        divClass:
        {
            type: String,
            default: ''
        },

        loading:
        {
            type: Boolean,
            default: false,
        }
    },
};

export const computed = {
    computed:
    {
        listeners()
        {
            const vm = this;

            return Object.assign({},
                this.$listeners,
                {
                    input: (event) =>
                    {
                        vm.$emit('input', event.target.value);
                    },

                    change: (event) =>
                    {
                        vm.$emit('onchange', event.target.value);
                    },
                }
            );
        },

        wrapperClasses()
        {
            return Text.joinClass(
                this.margin && 'vh-margin'
            );
        },

        classes()
        {
            return Text.joinClass(
                'vh-select',
                this.blank ? 'vh-form-blank' :
                    !this.border && 'vh-border-none',
                this.success && 'vh-form-success',
                this.size && `vh-form-${this.size}`,
                this.width && `vh-form-width-${this.width}`,
                this.error && 'vh-form-danger'
            );
        },

        labelClasses()
        {
            return Text.joinClass(
                'vh-form-label',
                'vh-text-bold',
                this.error && 'vh-text-danger',
                this.success && 'vh-text-success'
            );
        },
    },
};
